import React from "react";
import { css } from "react-emotion";
import NewsLetterObject from "./NewsLetterObject";
import FAQObject from "./FAQObject";
import * as styles from "../newStyles.styles";

const newsletterContainer = css`
  display: flex;
  flex-wrap: wrap;
  padding: 40px 15px;
  :not(:first-child) {
    border-top: 1px solid rgb(218, 218, 218);
  }
  /* border-bottom: 1px solid rgb(218, 218, 218); */
`;

const faqContainer = css`
  padding: 40px 15px;
  max-width: 602px;
`;

const col = css`
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
`;
const col12 = css`
  flex: 0 0 100%;
  max-width: 100%;
`;

const colMd4 = css`
  @media (min-width: 768px) {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
`;

const colMd8 = css`
  @media (min-width: 768px) {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }
  transition: all 1000ms ease;
  -moz-transition: all 1000ms ease;
  -ms-transition: all 1000ms ease;
  -o-transition: all 1000ms ease;
  -webkit-transition: all 1000ms ease;
`;

function FAQContainer({ title, campaigns, isFAQ, ...props }) {
  if (!campaigns) return null;

  const renderFAQs = () => {
    if (isFAQ)
      return (
        <div>
          {campaigns.map((qa) => {
            return <FAQObject qaObj={qa} key={qa.id} />;
          })}
        </div>
      );
  };

  const renderNewsletters = () => {
    if (campaigns)
      return (
        <div>
          {campaigns.map((qa) => {
            return <NewsLetterObject qaObj={qa} key={qa.id} />;
          })}
        </div>
      );
  };

  return (
    <div className={isFAQ ? faqContainer : newsletterContainer}>
      {isFAQ ? null : (
        <div className={col + " " + col12 + " " + colMd4}>
          <h4>{title}</h4>
        </div>
      )}
      {isFAQ ? (
        <div className={col + " " + col12}>{renderFAQs()}</div>
      ) : (
        <div className={col + " " + col12 + " " + colMd8}>
          {renderNewsletters()}
        </div>
      )}
    </div>
  );
}

export default FAQContainer;
